export default __webpack_public_path__ + "static/1141-30f0d857d9d03e6d68a26cf82aadecf3.gif";